module.exports = __webpack_public_path__ + "static/media/editea_plugin_tokens.87ff1ea7.png";